export const FETCH_PARTNERS_REQUEST = 'FETCH_PARTNERS_REQUEST';
export const FETCH_PARTNERS_SUCCESS = 'FETCH_PARTNERS_SUCCESS';
export const FETCH_PARTNERS_FAILURE = 'FETCH_PARTNERS_FAILURE';

export const FETCH_PARTNER_REQUEST = 'FETCH_PARTNER_REQUEST';
export const FETCH_PARTNER_SUCCESS = 'FETCH_PARTNER_SUCCESS';
export const FETCH_PARTNER_FAILURE = 'FETCH_PARTNER_FAILURE';

export const CREATE_PARTNER_REQUEST = 'CREATE_PARTNER_REQUEST';
export const CREATE_PARTNER_SUCCESS = 'CREATE_PARTNER_SUCCESS';
export const CREATE_PARTNER_FAILURE = 'CREATE_PARTNER_FAILURE';

export const UPDATE_PARTNER_REQUEST = 'UPDATE_PARTNER_REQUEST';
export const UPDATE_PARTNER_SUCCESS = 'UPDATE_PARTNER_SUCCESS';
export const UPDATE_PARTNER_FAILURE = 'UPDATE_PARTNER_FAILURE';

export const DELETE_PARTNER_REQUEST = 'DELETE_PARTNER_REQUEST';
export const DELETE_PARTNER_SUCCESS = 'DELETE_PARTNER_SUCCESS';
export const DELETE_PARTNER_FAILURE = 'DELETE_PARTNER_FAILURE';

export const FETCH_ETABLISSEMENTS_REQUEST = 'FETCH_ETABLISSEMENTS_REQUEST';
export const FETCH_ETABLISSEMENTS_SUCCESS = 'FETCH_ETABLISSEMENTS_SUCCESS';
export const FETCH_ETABLISSEMENTS_FAILURE = 'FETCH_ETABLISSEMENTS_FAILURE';

export const CREATE_ETABLISSEMENT_REQUEST = 'CREATE_ETABLISSEMENT_REQUEST';
export const CREATE_ETABLISSEMENT_SUCCESS = 'CREATE_ETABLISSEMENT_SUCCESS';
export const CREATE_ETABLISSEMENT_FAILURE = 'CREATE_ETABLISSEMENT_FAILURE';

export const UPDATE_ETABLISSEMENT_REQUEST = 'UPDATE_ETABLISSEMENT_REQUEST';
export const UPDATE_ETABLISSEMENT_SUCCESS = 'UPDATE_ETABLISSEMENT_SUCCESS';
export const UPDATE_ETABLISSEMENT_FAILURE = 'UPDATE_ETABLISSEMENT_FAILURE';

export const DELETE_ETABLISSEMENT_REQUEST = 'DELETE_ETABLISSEMENT_REQUEST';
export const DELETE_ETABLISSEMENT_SUCCESS = 'DELETE_ETABLISSEMENT_SUCCESS';
export const DELETE_ETABLISSEMENT_FAILURE = 'DELETE_ETABLISSEMENT_FAILURE';

export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';

export const UPDATE_USERPARTNER_REQUEST = 'UPDATE_USERPARTNER_REQUEST';
export const UPDATE_USERPARTNER_SUCCESS = 'UPDATE_USERPARTNER_SUCCESS';
export const UPDATE_USERPARTNER_FAILURE = 'UPDATE_USERPARTNER_FAILURE';

export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

export const SEND_USER_ACTIVATION_REQUEST = 'SEND_USER_ACTIVATION_REQUEST';
export const SEND_USER_ACTIVATION_SUCCESS = 'SEND_USER_ACTIVATION_SUCCESS';
export const SEND_USER_ACTIVATION_FAILURE = 'SEND_USER_ACTIVATION_FAILURE';

export const UPLOAD_LOGO_REQUEST = 'UPLOAD_LOGO_REQUEST';
export const UPLOAD_LOGO_SUCCESS = 'UPLOAD_LOGO_SUCCESS';
export const UPLOAD_LOGO_FAILURE = 'UPLOAD_LOGO_FAILURE';


